import Vue from 'vue';

const PREPARE_PAYMENT_URL = '/payment/prepare';
const PREPARE_PAYMENT_WITH_CARD_URL = '/payment/prepare-with-card';
const ADD_BALANCE_URL = '/payment/add-balance';
const GET_RECEIPT_LIST_URL = '/payment/receipt-list';
const GET_PAYMENT_REPORT_URL = '/payment/payment-report';

class PaymentService {

    async prepare(data) {
        return await Vue.prototype.$axios.post(PREPARE_PAYMENT_URL, data);
    }

    async prepareWithCard(data) {
        return await Vue.prototype.$axios.post(PREPARE_PAYMENT_WITH_CARD_URL, data);
    }

    async addBalance(data) {
        return await Vue.prototype.$axios.post(ADD_BALANCE_URL, data);
    }

    async getReceiptList(data) {
        return await Vue.prototype.$axios.post(GET_RECEIPT_LIST_URL, data);
    }

    async getPaymentReport(data) {
        return await Vue.prototype.$axios.post(GET_PAYMENT_REPORT_URL, data);
    }
}

export default new PaymentService();
